import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';

export function Loader({ circular = true, ...props }) {
	if (circular) return <CircularProgress {...props} />;
	else return <LinearProgress {...props} />;
}
